import { Link, useNavigate } from "react-router-dom";
import { Form } from "react-router-dom";
import classes from './UserItem.module.css';
import { useState, useContext } from "react";
import AuthContext from "../../../store/auth-context";
import { getAuthToken } from "../../../util/auth";
import { getApiChara } from "../../../util/getApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUser, FaIdCard, FaUserTag, FaEnvelope, FaPhoneAlt, FaEdit, FaTrash, FaArrowLeft } from 'react-icons/fa';
import ConfirmModal from "../../UI/ConfirmModal";

function UserItem({ userInfo }) {
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const startDeleteHandler = () => {
    setShowDeleteConfirm(true);
  }

  const confirmDeleteHandler = async () => {

    setIsDeleting(true);
    try {
      const tenantOrClientId = authCtx.tenantOrClientId;
      const mobile = userInfo ? userInfo?.mobile : '';
      const token = getAuthToken();
      if (token === null || token === 'EXPIRED') {
        navigate('/');
      }
      const apiChar = getApiChara();
      const apiUrl = `${apiChar}/users/deleteUserByMobile?mobile=${mobile}&tenantOrClientId=${tenantOrClientId}`;

      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });

      if (!response.ok) {
        toast.error("Could not delete user");
        throw new Error("Could not delete user");
      } else {
        setIsDeleting(false);
        toast.success("User deleted successfully!");
        navigate('..');
      }
    } catch (error) {
      console.error("Error deleting users:", error);
      setIsDeleting(false);
      setShowDeleteConfirm(false);
    }
  }

  return (
    <>
      <article className={classes.patient}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h3 className='textHead' style={{ color: 'var(--primary-color)', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px' }}>
            <FaUser className="me-2" /> User: {userInfo?.firstName + " " + userInfo?.lastName}
          </h3>
          <div className={classes.cardview}>
            <Form method="post" className={classes.form}>

              <div className={classes.sectionHeader}>
                <FaIdCard /> Personal Information
              </div>

              <div className="row">
                <div className="col-md-4 col-6">
                  <label className={classes.label} htmlFor="userId">User ID</label>
                  <input id="userId" type="text" name="userId" required defaultValue={userInfo ? userInfo?.userId : ''} disabled />
                </div>
                <div className="col-md-4 col-6">
                  <label className={classes.label} htmlFor="firstName">First Name</label>
                  <input id="firstName" type="text" name="firstName" required defaultValue={userInfo ? userInfo?.firstName : ''} disabled />
                </div>
                <div className="col-md-4 col-6">
                  <label className={classes.label} htmlFor="middleName">Middle Name</label>
                  <input id="middleName" type="text" name="middleName" required defaultValue={userInfo ? userInfo?.middleName : ''} disabled />
                </div>
                <div className="col-md-4 col-6">
                  <label className={classes.label} htmlFor="lastName">Last Name</label>
                  <input id="lastName" type="text" name="lastName" required defaultValue={userInfo ? userInfo?.lastName : ''} disabled />
                </div>
              </div>

              <div className={classes.sectionHeader}>
                <FaUserTag /> Account & Role
              </div>
              <div className="row">
                <div className="col-md-4 col-6">
                  <label className={classes.label} htmlFor="userName">User Name</label>
                  <input id="userName" type="text" name="userName" required defaultValue={userInfo ? userInfo?.userName : ''} disabled />
                </div>
                <div className="col-md-4 col-6">
                  <label className={classes.label} htmlFor="role">Role</label>
                  <select id="role" name="role" defaultValue={userInfo ? userInfo?.role : ''} disabled>
                    <option value="ROLE_ACCOUNTANT">Accountant </option>
                    <option value="ROLE_ADMIN">Admin </option>
                    <option value="ROLE_DOCTOR">Doctor</option>
                    <option value="ROLE_GUESTDOCTOR">Guest Doctor </option>
                    <option value="ROLE_MANAGER">Manager </option>
                    <option value="ROLE_NURSE">Nurse </option>
                    <option value="ROLE_PHARMACIST">Pharmacist </option>
                    <option value="ROLE_RECEPTIONIST">Receptionist</option>
                  </select>
                </div>
              </div>

              <div className={classes.sectionHeader}>
                <FaPhoneAlt /> Contact Information
              </div>
              <div className="row">
                <div className="col-md-6 col-6">
                  <label className={classes.label} htmlFor="email">Email</label>
                  <input id="email" type="email" name="email" defaultValue={userInfo ? userInfo?.email : ''} disabled />
                </div>
                <div className="col-md-6 col-6">
                  <label className={classes.label} htmlFor="mobile">Mobile Number</label>
                  <input id="mobile" type="tel" name="mobile" required defaultValue={userInfo ? userInfo?.mobile : ''} disabled />
                </div>
              </div>

              <div className={classes.actions}>
                <Link className={classes.editBtn} to="edit">
                  <FaEdit className="me-2" /> Edit User
                </Link>
                <button
                  type="button"
                  className={classes.deleteBtn}
                  onClick={startDeleteHandler}
                  disabled={isDeleting}
                >
                  <FaTrash className="me-2" /> {isDeleting ? "Deleting..." : 'Delete'}
                </button>
                <Link className={classes.backBtn} to="..">
                  <FaArrowLeft className="me-2" /> Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </article>
      <ConfirmModal
        show={showDeleteConfirm}
        onHide={() => setShowDeleteConfirm(false)}
        onConfirm={confirmDeleteHandler}
        title="Delete User"
        message={`Are you sure you want to delete user ${userInfo?.firstName} ${userInfo?.lastName}? This action cannot be undone.`}
        variant="danger"
        isLoading={isDeleting}
      />
    </>
  );
}

export default UserItem;
